import React from 'react';
import TechnologiesSwitcher from '../../../../components/technologies.component';

export const HomeContentWBT = props => (
  <div className='check-list-item'>
    <div className='check-list-item-progress'>
      <div className='check-list-item-index'>
      </div>
      <div className='check-list-item-sep'>
      </div>
    </div>
    <div className='check-list-item-body'>
      <p className='title'>
        <b>WBT LLC</b> <span><span className='no-mobile'>/ </span>2009 - May 2018</span>
      </p>
      <TechnologiesSwitcher>
        <div>
          <p>
            <b>Lead software developer (full stack, part time first 1.5 years)</b>
          </p>
          <p>I developed web applications for university including database design for RDBMS, implementing designs for web applications, configuring Unix/Linux systems and its administration and unit testing</p>
          <p>I took part at open source projects, i.e. <a
            href='http://circumflex.ru'
            target='_blank'
            rel='noopener noreferrer'>circumflex</a>.</p>
          <p>I took part at developing web application for content delivery and creation.</p>
          <p>I wrote maintainable and extensible code in a team environment and also modified existing software to correct errors, upgrade interfaces and improve performance.</p>
        </div>
        <div>
          <div className='project-list'>
            <div className='project-list-item'>
              <div className='project-list-title'>General technologies</div>
              <div className='project-list-technologies'>
                <div>Databases: PostreSQL, MongoDB.</div>
                <div>Scala, Node.js</div>
                <div>Web development.</div>
                <div>CSS, HTML, JavaScript</div>
                <div>For more info see above.</div>
              </div>
            </div>
            <div className='project-list-item'>
              <div className='project-list-title'>
                <a href='http://eduarea.com'
                   target='_blank'
                   rel='noopener noreferrer'>EduArea</a>
              </div>
              <div
                className='project-list-description'>educational platform for universities, including course development for universities (an ancestor of savant.pro)
              </div>
              <div
                className='project-list-technologies project-list-technologies--inline'>
                <div>Scala</div>
                <div>Quartz</div>
                <div>PostgreSQL</div>
                <div>Redis</div>
              </div>
            </div>
            <div className='project-list-item'>
              <div className='project-list-title'>
                <a href='http://circumflex.ru/'
                   target='_blank'
                   rel='noopener noreferrer'>Circumflex</a>
              </div>
              <div
                className='project-list-description'>application framework for quick and robust application development using Scala programming language
              </div>
              <div
                className='project-list-technologies project-list-technologies--inline'>
                <div>Scala</div>
                <div>SQL Databases</div>
                <div>FreeMarker</div>
              </div>
            </div>
            <div className='project-list-item'>
              <div className='project-list-title'>
                <a href='https://rfei.ru/'
                   target='_blank'
                   rel='noopener noreferrer'>rfei.ru</a>
              </div>
              <div
                className='project-list-description'>Main web site for for Regional Financial and Economic Institute
              </div>
              <div
                className='project-list-technologies project-list-technologies--inline'>
                <div>Scala</div>
                <div>PostgreSQL</div>
              </div>
            </div>
          </div>
        </div>
      </TechnologiesSwitcher>
    </div>
  </div>
);
